import { render, staticRenderFns } from "./dialogInvitation.vue?vue&type=template&id=40a78a8d&scoped=true&"
import script from "./dialogInvitation.vue?vue&type=script&lang=js&"
export * from "./dialogInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a78a8d",
  null
  
)

export default component.exports